import WeekScore from "./WeekScore";

export default WeekScore;
